var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 5.33333H5.33333V0H21.3333V5.33333ZM21.3333 12.6667C21.7111 12.6667 22.028 12.5387 22.284 12.2827C22.54 12.0267 22.6676 11.7102 22.6667 11.3333C22.6658 10.9564 22.5378 10.64 22.2827 10.384C22.0276 10.128 21.7111 10 21.3333 10C20.9556 10 20.6391 10.128 20.384 10.384C20.1289 10.64 20.0009 10.9564 20 11.3333C19.9991 11.7102 20.1271 12.0271 20.384 12.284C20.6409 12.5409 20.9573 12.6684 21.3333 12.6667ZM18.6667 21.3333V16H8V21.3333H18.6667ZM21.3333 24H5.33333V18.6667H0V10.6667C0 9.53333 0.388889 8.58356 1.16667 7.81733C1.94444 7.05111 2.88889 6.66756 4 6.66667H22.6667C23.8 6.66667 24.7502 7.05022 25.5173 7.81733C26.2844 8.58444 26.6676 9.53422 26.6667 10.6667V18.6667H21.3333V24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/PrintIcon.90923976f5cf1a945e8ca33c897be661.svg";
export { ForwardRef as ReactComponent };